import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useAppDispatch } from "@/redux/hooks";

import { openPanel } from "@/pages/Private/redux/notification/notification.slice";

/** Query param an incoming link uses to ask for the notification panel: `?panel=notifications`. */
export const PANEL_PARAM = "panel";
export const PANEL_PARAM_VALUE = "notifications";

/**
 * Opens the notification panel when a link points at it. The notification centre is a panel in the
 * app shell rather than a page, so an e-mail ("View all notifications") can only deep-link it via a
 * query param on a real page — pointing at a `/app/notifications` route rendered "Page Not Found"
 * (PREC-3789).
 *
 * The param is stripped again once handled, so a reload (or a back-navigation) doesn't re-open the
 * panel the user just closed.
 */
export const useNotificationPanelDeepLink = (): void => {
	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		if (searchParams.get(PANEL_PARAM) !== PANEL_PARAM_VALUE) {
			return;
		}

		dispatch(openPanel());

		setSearchParams(
			(prev) => {
				const next = new URLSearchParams(prev);

				next.delete(PANEL_PARAM);

				return next;
			},
			{ replace: true }
		);
	}, [searchParams, setSearchParams, dispatch]);
};
